import { load } from "recaptcha-v3";

const getCaptchaV3Token = async (siteKey: string) => {
  const recaptcha = await load(siteKey);
  return recaptcha.execute("validate_captcha");
};

export { getCaptchaV3Token };
